<template>
  <div class="flex items-center gap-4">
    <button
      @click="handleGoBack"
      class="w-10 h-10 flex items-center justify-center bg-white hover:bg-gray-50 border border-gray-200 rounded-xl shadow-sm transition-colors"
    >
      <i class="fa-solid fa-arrow-left text-gray-700"></i>
    </button>
    <h3 class="text-lg font-bold text-gray-900 mb-0">{{ title }}</h3>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'GoBackTitle',
  props: {
    title: {
      type: String,
      required: true
    },
    // Route de destination (optionnel)
    to: {
      type: [String, Object],
      default: null
    },
    // Fonction personnalisée pour le retour (optionnel)
    onBack: {
      type: Function,
      default: null
    }
  },
  emits: ['back'],
  setup(props, { emit }) {
    const router = useRouter()

    const handleGoBack = () => {
      // Émettre l'événement
      emit('back')

      // Si une fonction personnalisée est fournie
      if (props.onBack) {
        props.onBack()
        return
      }

      // Si une route est fournie
      if (props.to) {
        router.push(props.to)
        return
      }

      // Sinon, retour à la page précédente
      router.back()
    }

    return {
      handleGoBack
    }
  }
})
</script>
